/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'renewal/h': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M16.798 18.043h-2.092v-5.37H9.302v5.37h-2.1V5.957h2.1v5.03h5.404v-5.03h2.092v12.086z" _fill="currentColor"/>'
  }
})
